import { StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import { TextTitle, TextTitleProps } from './TextTitle';

export interface StandaloneTextTitleProps extends StandaloneComponentProps {
  title: string;
  options?: Omit<TextTitleProps, 'title'>;
}

export const StandaloneTextTitle: StandaloneComponent<StandaloneTextTitleProps> = ({ title, options, ...props }) => {
  return (
    <TextTitle {...options} {...props}>
      {title}
    </TextTitle>
  );
};

export default StandaloneTextTitle;
